export default __webpack_public_path__ + "036d010f39249a5583e603d6cda7b423.png";